// @flow
import type {ActiveSortType} from 'constants/flow/flowTypes';
import {CATEGORY_SORT} from 'constants/sort';

import {getUrlParams} from 'libs/url';

/**
 * Parse url params and return object
 * @param {string} searchParams - URL search parameters
 * @return {ActiveSortType} - active sort
 */
export const getSortFromUrl = (searchParams?: string): ActiveSortType => {
    const {order} = getUrlParams(searchParams);

    // Check sort in url;
    const urlOrder =
        order && order.length === 2
            ? {
                  value: order[1],
                  option: order[0],
              }
            : {};

    // Get and return final sort
    const foundSort = CATEGORY_SORT.find(
        item => item.option === urlOrder.option && item.value === urlOrder.value,
    );
    return foundSort || {...CATEGORY_SORT[0], value: null, option: null};
};
